import { onUnmounted, ref } from 'vue'

export function useResendTimer(initialSeconds = 60) {
  const secondsLeft = ref(0)
  const canResend = ref(true)
  let timer: ReturnType<typeof setInterval> | null = null

  function clear() {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  function start(seconds = initialSeconds) {
    clear()
    secondsLeft.value = seconds
    canResend.value = false
    timer = setInterval(() => {
      secondsLeft.value -= 1
      if (secondsLeft.value <= 0) {
        clear()
        canResend.value = true
      }
    }, 1000)
  }

  onUnmounted(clear)

  return { secondsLeft, canResend, start, clear }
}
